export default function _isPlaceholder(a) {
       return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}


//////////////////
// WEBPACK FOOTER
// ./~/ramda/es/internal/_isPlaceholder.js
// module id = 502
// module chunks = 2